import React, {Component} from "react";
import YouTube from 'react-youtube';
import "./index.css";

export default class NoControlsYoutubeEmbed extends Component {

  state = {
    disabled: false,
    video: null,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.currentIndex !== this.props.currentIndex) {
      this.stopVideos()
    }
  }

  //https://youtu.be/M1OGNLAH_XM

  makeUrl = () => {
    let videoId = this.props.url.split('/')
    return `https://www.youtube.com/embed/${videoId[videoId.length - 1]}?modestbranding=1&rel=0&enablejsapi=1`
  }

  stopVideos = () => {
    let iframe = document.getElementById(`embed${this.props.index}`) //element.querySelector( 'iframe');
    if (iframe && this.props.index !== this.props.currentIndex) {
      let iframeSrc = iframe.src;
      iframe.src = iframeSrc;
    }
  };

  getVideoId = () => {
    let videoUrl = this.props.url.split('/');
    return videoUrl[videoUrl.length - 1];
  }

  pauseVideo = () => {
    this.state.video && this.state.video.pauseVideo();
  }

  playVideo = (mute=false) => {
    this.state.video && this.state.video.playVideo();
    if (mute) {
      this.state.video && this.state.video.mute();
    } else {
      this.state.video && this.state.video.unMute();
    }
  }

  muteVideo = () => {
    this.state.video && this.state.video.mute();
  }

  unmuteVideo = () => {
    this.state.video && this.state.video.unMute();
  }

  render = () => {
    return (
      <div style={{textAlign: "center", width: "100%"}}>
        <YouTube
          id={`embed${this.props.index}`}
          videoId={this.getVideoId()}
          onReady={(e) => {this.setState({video: e.target}, () => this.playVideo(true))}}
          containerClassName={"youtubeContainer"}
          opts={{
            // width: this.props.width || window.innerWidth, 
            // height: this.props.height || Math.floor(window.innerWidth / 16 * 9), 
            position: "relative", 
            float: "left",
            playerVars: {
              autoplay: 1,
              loop: 1,
              controls: 0,
              disablekb: 1,
              modestbranding: 1,
              playsinline: 1,
              rel: 0,
              playlist: this.getVideoId()
            }}}
        />
      </div>
    )
  }
}